import React, { useEffect, useState } from 'react';
import MenuCategoriesFloat from './MenuCategoriesFloat';
import { useLoginContext } from '../../Contexts/LoginContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Search from './Search';
import ButtonsViewMode from './ButtonsViewMode';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import ButtonCustomerOrders from './ButtonCustomerOrders';
import { useStoreContext } from '../../Contexts/StoreContext';
import { useOrderTypeContext } from '../../Contexts/OrderTypeContext';
import { TbBuildingSkyscraper, TbClock, TbShoppingBag, TbUser, TbUserSquareRounded } from 'react-icons/tb';
import { useCartContext } from '../../Contexts/CartContext';
import SelectedProduct from './Product/SelectedProduct';
import ButtonPrimary from '../Form/ButtonPrimary';
import Img from './Img';
import { ORDER_TYPE_ICONS, ORDER_TYPE_LABELS } from '../../Utils/Constants/Service';
import { useCheckoutContext } from '../../Contexts/CheckoutContext';
import BadgeIndicator from './Product/BadgeIndicator';
import { useStoreHook } from '../../Hooks/StoreHook';

interface HeaderProps {
    categories: any;
}

const Header = ({
    categories,
}: HeaderProps) => {

    const { token, setShowLoginBasic, user } = useLoginContext();
    const { company, isMobile, companyPages } = useLayoutContext();
    const { currentStore } = useStoreContext();
    const { orderType, isStoreCounter } = useOrderTypeContext();
    const { currentCart, loadingCurrentCart, loadingUpdateQuantity, setShowCart, getTotalQuantityProductsInConference, currentCartHasItems } = useCartContext();
    const { order } = useCheckoutContext();
    const { getLinkToHome } = useStoreHook();

    const headerMenu = [
        // { name: 'Home', href: getLinkToHome() },
        { name: 'Lojas', href: '/lojas' },
        // { name: 'Fidelidade', href: '#' },
        // { name: 'Pagamento', href: `${getLinkToHome()}/checkout` },
    ]

    const location = useLocation();
    const linkActived = 'text-custom-primary pointer-events-none'
    const isHome = location.pathname === getLinkToHome();

    const [searching, setSearching] = useState(false);
    const handleHeaderLayout = (searching: boolean) => {
        setSearching(searching);
    }

    const goToOrderPlace = () => {
        navigate(`${getLinkToHome()}/order/${order.id}/placed`);
    }

    useEffect(() => {
        // console.log('companyPages', companyPages)
    }, [companyPages])

    const navigate = useNavigate();
    const handleOpenCart = () => {
        // if (order) {
        //     goToOrderPlace();
        // } else {
            setShowCart(true);
        // }
    }

    const handleOpenLogin = () => {
        return !token ? setShowLoginBasic(true) : navigate('/perfil/meus-pedidos');
    }

    return (
        <>
            {/* TOP HEADER */}
            {/* <header className='flex px-2 md:px-4 py-2 justify-center w-full bg-custom-topbar text-custom-topbar-text shadow-inner font-medium'>
                <div className="w-full flex text-[11px] justify-between flex-col md:flex-row">// md:max-w-[1460px]
                    <div className="flex gap-2 md:flex-row-reverse">
                        <div className="flex gap-0.5 w-full md:w-auto items-center font-bold">
                            <TbMapPin />
                            <span>Praia de Botafogo, 300 <span className="hidden md:inline">- 22250040</span></span>
                        </div>
                        <div className="flex gap-2">
                            <button
                                type="button"
                                className="flex gap-0.5 leading-3 text-nowrap items-center text-custom-primary rounded-full px-2 py-0.5 font-semibold ring-1 ring-gray-200 hover:ring-2 hover:ring-custom-primary transition-color ease-in-out duration-200"
                                onClick={() => setShowOrderTypeChoice(true)}
                            >
                                { ORDER_TYPE_ICONS[orderType as keyof typeof ORDER_TYPE_ICONS] }
                                { ORDER_TYPE_LABELS[orderType as keyof typeof ORDER_TYPE_LABELS] }
                            </button>
                        </div>
                    </div>
                    <div className="flex divide-x divide-x-0 md:divide-x">
                        <div className="pr-2 flex gap-0.5 w-full md:w-auto items-center">
                            <TbClock />Estimativa de entrega:
                            <span className="font-bold">50 Min</span>
                        </div>
                        <div className="pl-2 flex items-center gap-0.5 text-nowrap items-center font-bold">
                            <TbBuildingSkyscraper />
                            <span>Bob's Praia de Botafogo</span>
                        </div>
                    </div>
                </div>
            </header> */}

            {(currentStore && !isStoreCounter) &&
                <header className='sticky top-0 flex px-2 md:px-4 justify-between py-2 w-full bg-custom-topbar text-custom-topbar-text shadow-inner font-medium text-xs'>
                    <div className='flex items-center gap-1'>
                        <span><TbBuildingSkyscraper /></span>
                        <span className="font-semibold">{currentStore.name}</span>
                    </div>
                    {orderType &&
                        <div className='flex items-center gap-1'>
                            <span>{ORDER_TYPE_ICONS[orderType as keyof typeof ORDER_TYPE_ICONS]}</span>
                            <span>{ORDER_TYPE_LABELS[orderType as keyof typeof ORDER_TYPE_LABELS]}</span>
                        </div>
                    }
                </header>
            }


            {/* HEADER */}
            <header className="flex flex-col w-full justify-between sticky bg-custom-header top-0 z-30 text-custom-header-text">
                <section className='flex p-4 justify-center shadow-sm shadow-black/5 h-20'>
                    <div className="flex items-center justify-between w-full md:max-w-[1460px] gap-4 md:gap-6">

                        {/* LOGO */}
                        <Link to={getLinkToHome()} className={`${isHome && 'pointer-events-none'}`}>
                            {company && <Img src={company.vector_image ?? company.image} alt="" className={`transition-width ease-in-out duration-200 ${searching && isMobile ? 'w-20' : 'w-24'}`} />}
                        </Link>

                        {/* MENU INLINE DESKTOP */}
                        <div className="flex items-center gap-3 lg:gap-5 text-xs hidden md:flex font-bold leading-4 text-nowrap transition-all ease-in-out duration-200">
                            {headerMenu.filter(item => item.href !== `/${currentStore?.slug || ''}`).map((item) => (
                                <div key={item.name}>
                                    <Link to={item.href} className={`hover:text-custom-primary ${location.pathname === item.href ? linkActived : 'text-gray-500'}`}>
                                        {item.name}
                                    </Link>
                                </div>
                            ))}
                        </div>

                        {/* SEARCH */}
                        {(currentStore && isHome) && (
                            <div className="flex flex-grow h-full">
                                <div className="relative flex items-center w-full">
                                    <Search onSearching={handleHeaderLayout} />
                                </div>
                            </div>
                        )}

                        {(!searching && currentStore && isHome) && (
                            <div className="flex items-center gap-2">
                                <ButtonsViewMode />
                                {token && <ButtonCustomerOrders />}
                            </div>
                        )}

                        <div className="hidden md:flex items-center gap-2 md:gap-2 h-full">

                            <ButtonPrimary
                                outline
                                onClick={handleOpenLogin}
                                className='items-center gap-0.5 text-sm justify-center h-10 px-0 py-0 md:ring-0 -ml-1 w-auto'>
                                <div>{ user ? <TbUserSquareRounded size={20} /> : <TbUser size={20} /> }</div>
                                <div>{ user ? 'Perfil' : 'Entrar' }</div>
                            </ButtonPrimary>

                            {(currentStore && order) &&
                                <div className='relative'>
                                    <ButtonPrimary
                                        outline
                                        onClick={goToOrderPlace}
                                        className='zoomInicon items-center justify-center h-10 w-10 px-0 py-0 md:ring-0 -ml-1'>
                                        <div><TbClock size={22} /></div>
                                        {(currentStore.shipping_time && currentStore.shipping_time > 0) && <BadgeIndicator quantity={currentStore.shipping_time} className="rounded-lg -top-0.5 -right-0.5" />}
                                    </ButtonPrimary>
                                </div>
                            }

                            <div className='relative'>
                                <ButtonPrimary
                                    outline
                                    disabled={!currentCartHasItems}
                                    onClick={handleOpenCart}
                                    className='items-center justify-center h-10 w-10 px-0 py-0 md:ring-0 -ml-1'>
                                    <div><TbShoppingBag size={22} /></div>
                                    <SelectedProduct alwaysNotify={false} loading={loadingCurrentCart || loadingUpdateQuantity} animated={false} quantity={currentCart ? getTotalQuantityProductsInConference(currentCart.items) : 0} className="rounded-lg -top-0.5 -right-0.5" />
                                </ButtonPrimary>
                            </div>

                            {/* <ButtonPrimary
                                outline
                                disabled
                                onClick={() => {}}
                                className='items-center justify-center h-10 w-10 px-0 py-0 md:ring-0 -ml-1'>
                                <div><HiBars3 size={21} /></div>
                            </ButtonPrimary> */}

                        </div>
                    </div>
                </section>

                {/* Float menu category */}
                {categories &&
                    <div className='flex justify-center w-full text-sm bg-custom-header shadow-md shadow-black/5'>
                        <div className="w-full md:max-w-[1460px]">
                            <MenuCategoriesFloat categories={categories} />
                        </div>
                    </div>
                }

            </header>
        </>
    );
};

export default Header;
